// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"60e5c4e5","7786":"0221467a"}[chunkId] + ".chunk.css";
};